var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 5,
    viewBox: "0 0 9 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.176135 0.137438C0.0591488 0.238763 -0.000109689 0.376413 -2.24888e-08 0.514484C-2.79616e-08 0.639687 0.0486526 0.765195 0.14716 0.864179L4.09613 4.83551C4.20043 4.94041 4.34672 5 4.50001 5C4.65331 5 4.79969 4.94041 4.90389 4.83551L8.85287 0.86418C9.05983 0.656019 9.04693 0.330611 8.82378 0.13736C8.60074 -0.055901 8.25208 -0.0437597 8.04502 0.164503L4.49993 3.72964L0.954837 0.164503C0.747872 -0.04376 0.399199 -0.0559014 0.17607 0.13736L0.176135 0.137438Z",
    fill: "#778CA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserArrow);
export default __webpack_public_path__ + "static/media/userArrow.83b82cb4e31872966535385e57b38b48.svg";
export { ForwardRef as ReactComponent };